import * as React from 'react';
import { Navigate } from 'react-router-dom';

import { canUseRecommender } from '../lib/recommenderAccess';


export default function RequireRecommenderAccess({ children }) {
  if (!canUseRecommender()) {
    return <Navigate to="/" replace />;
  }
  return children;
}
